import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";

export class LayoutRight extends BaseComponent<ILayoutRightProps, ILayoutRightState>
{
    public render(): JSX.Element
    {
        return (
            <>
                {this.props.children}
            </>
        );
    }
}

export interface ILayoutRightProps
{
    children: ReactNode;
}

export interface ILayoutRightState { }
